module.exports = __webpack_public_path__ + "static/media/TVMount.598624d0.jpg";